<script lang="ts">
  import { onDestroy, onMount, setContext } from 'svelte';
  import { modalComponent } from './modal-store';
  import { removeHash } from './utils';

  let isClosing: boolean = false;
  const body = document.querySelector('body');
  const containerElement = document.querySelector('#container');

  setContext<{ closeModal: () => void }>('modal', { closeModal });

  onMount(() => {
    body.classList.add('modal-opened');
    window.addEventListener('popstate', closeModal, false);
    containerElement.classList.add('u-backdrop');
  });

  onDestroy(() => {
    body.classList.remove('modal-opened');
    window.removeEventListener('popstate', closeModal, false);
  });

  function setHideModal() {
    const container = document.querySelector('#modal-container');
    container.classList.add('animate-hide');
    body.classList.remove('modal-opened');
    containerElement.classList.remove('u-backdrop');
    isClosing = true;
  }

  function closeModal() {
    removeHash();
    setHideModal();

    setTimeout(() => {
      modalComponent.set(null);
    }, 292);
  }

  function observeKeypress(event: KeyboardEvent) {
    const { code, key } = event;

    if (code === 'Escape' || key === 'Escape') {
      closeModal();
    }
  }
</script>

<svelte:window on:keyup={observeKeypress} />

<div
  id="modal-container"
  class={`fixed z-[1000] inset-0 w-full bg-white overflow-y-auto ${$modalComponent.app}-bg-light animate-show pb-inset-bottom pt-inset-top pr-inset-right pl-inset-left selection:bg-blue-bg selection:text-white`}
>
  <div
    class="relative h-[80px] sm:h-[104px] md2:h-[80px] lg:h-[96px] xl:h-[120px] flex items-center"
  >
    <button
      class:hidden={isClosing}
      class="fixed top-6 right-6 md2:top-4 md2:right-8 border outline border-strong-gray hover:border-black active:border-strong-gray rounded-[50%] p-2 z-10"
      on:click={closeModal}
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="w-[30px]" viewBox="0 0 512 512">
        <title>Close</title>
        <path
          fill="none"
          stroke="#757575"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="32"
          d="M368 368L144 144M368 144L144 368"
        />
      </svg>
    </button>
  </div>
  <div class="animate-slideIn flex flex-col min-h-[calc(100vh-80px)] sm:min-h-[calc(100vh-104px)] md2:min-h-[calc(100vh-80px)] lg:min-h-[calc(100vh-96px)] xl:min-h-[calc(100vh-120px)]" 
    class:animate-slideFadeOut={isClosing}>
    <svelte:component this={$modalComponent.component} />
  </div>
</div>

<style>
  .color-white:active {
    @apply text-white;
  }
  .contact-form-bg-light {
    @apply bg-blue-bg;
  }
  .uniapp-bg-light {
    @apply bg-uniapp-bg-light;
  }
  .wellabe-bg-light {
    @apply bg-wellabe-bg-light;
  }

  .md-integrations-bg-light {
    @apply bg-md-integrations-bg-light;
  }
</style>
